<app-splash-screen></app-splash-screen>
<div class="loader_page">
  <app-pro-toggle *ngIf="api.userInfo && api.pinUnlocked"></app-pro-toggle>
  <div [@triggerName]="!nav.demoMode && prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
  <app-nav *ngIf="checkWelcomeDone() && api.userInfo && api.userInfo?.pinHash && api.userInfo?.nationalNumber && !onSpecialRoute() && !api.setPrincipalMode && (!api.setNewVoucherMode || (api.setNewVoucherMode && !this.api.isVoucherExpired))"></app-nav>
</div>
<lib-version [version]="api.env.appVersion" [production]="api.env.production"></lib-version>
